module.exports = "/_next/static/images/85f3daf5d650e2d1c57ac278582646fd-bag.svg";